import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { push } from 'react-router-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Button, ModalRemove, TextIcon } from 'advenio-components'
import ContractIsland from '../../Components/ContractIsland/ContractIsland'
import ContractsActions from '../../Data/Redux/ContractsRedux'
import { userHasRole } from 'utils/Utils'
import { sum } from 'ramda'

const ContractsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 16px;
`
// const Col = styled.div`
//   flex-basis: 50%;
//   padding: 8px;
//   box-sizing: border-box;

//   @media (max-width:767px) {
//     flex-basis: 100%;
//   }
// `
const Col = styled.div`
	padding: 3px;
	display: inline-block;
	width: 49%;
`
const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
`

class CompanyContractsForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalRemoveOpened: false,
      toRemoveData: {},
    }
  }

  onAddContract = () => this.props.goToAddContractsProcess()

  onRemove = data => () => this.setState({
    toRemoveData: data,
    modalRemoveOpened: true,
  })

  onedit = data => () => {
    const { goToContract, match: { params } } = this.props
    const id = params.id
    const contractId = data.contract.id
    const contractType = data.contract.contract_type.toLowerCase() === 'with support' ? 'with-support' : 'without-support'
    goToContract(`/companies/${id}/add-contract/${contractType}/${contractId}`)
  }

  onRestore = data => () => {
    const { restoreContract } = this.props
    const contractId = data.contract.id
    restoreContract(contractId)
  }

  renderContracts = (contracts, flawNoContracts = null) => {
    const { company: { country }, user } = this.props
    return contracts.map((contract) => {
      let studentTotal = 0
      studentTotal += sum(contract.products.map(p => p.students_totals))
      return (
        <Col key={contract.id}>
          <ContractIsland
            contract={contract}
            country={country}
            onDelete={!userHasRole(user, ['Receptionist', 'Director', 'Coordinator']) && studentTotal < 1 ? this.onRemove : null}
            onEdit={!userHasRole(user, ['Receptionist', 'Director', 'Coordinator']) ? this.onedit : null}
            onRestore={this.onRestore}
            flawNoContracts={flawNoContracts}
          />
        </Col>
      )
    })
  }

  onCloseModalRemove = () => this.setState({ modalRemoveOpened: false })

  render() {
    const { contracts, noActvieContracts, user } = this.props
    const { modalRemoveOpened, toRemoveData } = this.state

    return (
      <div>
        {!userHasRole(user, ['Receptionist', 'Director', 'Coordinator']) && noActvieContracts === undefined ?
          <Buttons>
            <Button primary onClick={this.onAddContract}>
              <TextIcon iconType="plus" label="Contrato" iconViewBox="-2 -2 24 24" />
            </Button>
          </Buttons> :
          ''
        }
        <ContractsContainer>
          {this.renderContracts(contracts, noActvieContracts !== undefined ? noActvieContracts : null)}
        </ContractsContainer>
        <ModalRemove
          requiresConfirmationInput
          isOpened={modalRemoveOpened}
          onClose={this.onCloseModalRemove}
          titleItem="contrato"
          statePath="contracts"
          typePrefix="CONTRACTS"
          toRemoveData={toRemoveData}
        />
      </div>
    )
  }
}

CompanyContractsForm.propTypes = {
  /** Data attributes from the current URI */
  match: PropTypes.object.isRequired,
  /** The Company currently being viewed */
  company: PropTypes.object.isRequired,
  /** Navigate to Add Contracts process */
  goToAddContractsProcess: PropTypes.func.isRequired,
  /** Navigate to Add Contracts process */
  goToContract: PropTypes.func.isRequired,
}

const mapStateToProps = ({ companies, ...state }) => ({
  company: companies.getOne.result,
  user: state.auth.user,
})

const mapDispatchToProps = (dispatch, { match }) => ({
  goToAddContractsProcess: () => dispatch(push(`${match.url}/add-contract/`)),
  restoreContract: id => dispatch(ContractsActions.contractRestoreRequest(id)),
  goToContract: link => dispatch(push(link)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CompanyContractsForm))



// WEBPACK FOOTER //
// ./src/Containers/CompanyContractsForm/CompanyContractsForm.jsx